import {
  formatedDay,
  formatedMonth,
  formatedPlace,
  formatedWeekday,
  formatedYear,
  locale,
  tcDays,
} from '../alpine-functions';

import {
  ALLOWED_LANGUAGES,
  FREE_TEXT,
  MORNING,
  AFTERNOON,
  HALF_DAY_AFTERNOON,
  HALF_DAY_MORNING,
  HALF_OCUPATION,
  LAST_AVAILABLE_PLACES_TEXT,
  SOLD_OUT_MARK,
  SOLD_OUT_TEXT,
  SOLD_OUT_THRESHOLD,
} from '../misc/consts';

import { readStoredCart, writeStoredCart } from '../misc/cart-storage';

const EVENT_SOLDOUT = {
  rowClass: 'events-table__event--full',
  btnText: 'Náhradník',
  btnClass: '',
  soldOut: true,
};
const EVENT_FREE = {
  rowClass: '',
  btnText: 'Rezervovat kurz',
  btnClass: 'btn--red',
  soldOut: false,
};

export default (event) => ({
  event: event,
  allowedLanguages: ALLOWED_LANGUAGES,
  locale: locale(),

  // Get half day period based on halfDay variable
  get isMorningPeriod() {
    return this.event?.is_morning ? MORNING : AFTERNOON;
  },

  // Get translation key for half day period
  get halfDayTranslationKey() {
    const period = this.isMorningPeriod;
    return period === MOMORNING ? HALF_DAY_MORNING : HALF_DAY_AFTERNOON;
  },

  //TODO: gobal function would be better this
  get formatedPlace() {
    return formatedPlace(this.event.event_type, this.event.city);
  },

  get soldOutThresholdReached() {
    let date = new Date(this.event.start);
    let currDate = new Date();
    let diffDays = (date.getTime() - currDate.getTime()) / (1000 * 3600 * 24);

    return diffDays < SOLD_OUT_THRESHOLD;
  },

  get lastPlacesThresholdReached() {
    let date = new Date(this.event.start);
    let currDate = new Date();
    let diffDays = (date.getTime() - currDate.getTime()) / (1000 * 3600 * 24);

    return diffDays <= 3;
  },

  get formatedCapacity() {
    if (this.soldOutThresholdReached || event.capacity === SOLD_OUT_MARK) {
      return SOLD_OUT_TEXT;
    }
    if (event.capacity === HALF_OCUPATION) {
      return LAST_AVAILABLE_PLACES_TEXT;
    }
    return FREE_TEXT;
  },

  get formatedDay() {
    return formatedDay(this.event.start).replace('.', '');
  },

  get formatedMonth() {
    return formatedMonth(this.event.start);
  },

  get formatedYear() {
    return formatedYear(this.event.start);
  },

  get formatedWeekday() {
    return formatedWeekday(this.event.start);
  },

  get formatedLanguage() {
    return this.allowedLanguages.find((language) => {
      return this.event.language.includes(language.locale);
    }).fullName;
  },

  get rowStatus() {
    return this.event.capacity === SOLD_OUT_MARK
      ? EVENT_SOLDOUT
      : EVENT_FREE;
  },

  get orderLink() {
    let querry = `?event=${this.event.id}`;
    if (this.selectedPackage.packageTitle !== null) {
      return querry + `&package=${this.selectedPackage.packageTitle}`;
    }
    return querry;
  },

  addToCart(event) {
    writeStoredCart([...readStoredCart(), event]);
    this.$dispatch('cart-updated', false);
  },

  //TODO: gobal function would be better this
  tcDays(duration, customDuration) {
    return tcDays(duration, customDuration);
  },
});
